{
  "subpage": {
    "test-results": {
      "header": "Test Results",
      "no-tests": "No tests",
      "result": {
        "arp": {
          "table": {
            "column": {
              "ip": "IP address",
              "mac": "MAC address",
              "name": "Name",
              "state": "State",
              "vlan": "VLAN ID"
            },
            "state": {
              "DELAY": "Delay",
              "FAILED": "Failed",
              "INCOMPLETE": "Incomplete",
              "PROBE": "Probe",
              "REACHABLE": "Reachable",
              "STALE": "Stale"
            }
          }
        },
        "back": "Back to Test results",
        "copy": "Copy Results",
        "created_at": "Test time",
        "error": {
          "api": "There was an error loading test results.",
          "delete": "Unable to delete $t(test.{{testId}}.name).",
          "download": {
            "404": "Log file could not be downloaded as it does not exist.",
            "unknown": "There was an unknown error while attempting to download the file."
          }
        },
        "flap-circuit": {
          "summary": {
            "error": "{{circuit}}: {{name}} interface reset failed.",
            "success": "{{circuit}}: {{name}} interface reset successful."
          },
          "wait": "Wait time"
        },
        "inputs": "Test inputs",
        "interface-statistics": {
          "table": {
            "column": {
              "autonegotiation": "Autonegotiation",
              "collisions": "Collisions",
              "ip": "IP address",
              "link": "Link detected",
              "mac": "MAC address",
              "port": "Port",
              "port_function": "Port function",
              "rx_errors": "RX errors",
              "speed": "Speed",
              "tx_errors": "TX errors"
            },
            "duplex": {
              "FULL": "Full duplex",
              "HALF": "Half duplex"
            },
            "link": {
              "false": "False",
              "true": "True"
            },
            "port_function": {
              "not_in_use": "Not in use"
            },
            "speed": {
              "unknown": "Unknown"
            }
          }
        },
        "key_value_pair": "{{key}}: <strong>{{value}}</strong>",
        "modified_by": "Run by",
        "new": "New",
        "no_summary": "This test doesn't have a summary, you need to view full results.",
        "output": "Test results",
        "output_summary": "Test results summary",
        "run_again": {
          "cta": "Run again",
          "error": "Unable to run $t(test.{{testId}}.name) again.",
          "success": "$t(test.{{testId}}.name) successfully ran again."
        },
        "see_full_results": "See full test results",
        "speed-test": {
          "download": "Download",
          "no_data": "No data available",
          "overall": "Overall",
          "ping": "Ping",
          "unknown": "Unknown",
          "upload": "Upload"
        },
        "state": {
          "finished": "Ready",
          "pending": "Queued",
          "processing error": "Errored",
          "running": "Running",
          "upload error": "Errored"
        },
        "title": "$t(test.{{testId}}.name) results"
      },
      "title": "Diagnostics results"
    },
    "tests": {
      "card": {
        "cta": "Choose this test"
      },
      "drawer": {
        "footer": {
          "cta": "Run test",
          "discard": "Discard test"
        },
        "header": "Tests"
      },
      "title": "Diagnostics tasks"
    }
  },
  "subtitle": "Perform tests to diagnose your site's state and get detailed metrics to troubleshoot issues and improve performance.",
  "test": {
    "arp": {
      "description": {
        "primary": "View contents of the device ARP table.",
        "secondary": "Perform test to verify the MAC address to IP address mapping and check the ARP cache status on the device."
      },
      "details": "Verify the MAC address to IP address mapping on the LAN/WAN interfaces that are connected to the device on which the test is run.",
      "name": "ARP table dump"
    },
    "error": {
      "invalid_fields": "We could not complete the test. Please try again."
    },
    "field": {
      "device": {
        "label": "Source Device",
        "placeholder": "Select a test device",
        "required": "Source Device is required",
        "yocto": {
          "label": "Device",
          "placeholder": "Select a test device",
          "required": "Device is required"
        }
      },
      "job_data": {
        "TTL": {
          "label": "TTL",
          "placeholder": "64"
        },
        "circuit": {
          "label": "Circuit",
          "placeholder": "Select a circuit"
        },
        "count": {
          "label": "Count",
          "placeholder": "5"
        },
        "direction": {
          "label": "Direction",
          "placeholder": "Set a direction"
        },
        "duration": {
          "label": "Duration (seconds)",
          "placeholder": "0"
        },
        "filter_expression": {
          "label": "Filter",
          "placeholder": "Appends to command"
        },
        "host": {
          "label": "Destination",
          "placeholder": "IP or host (ex: www.google.com)",
          "required": "Destination is required"
        },
        "iface": {
          "label": "Source Interface",
          "placeholder": "Select an interface",
          "required": "Source Interface is required"
        },
        "interval": {
          "label": "Interval (in seconds)",
          "placeholder": "1"
        },
        "multiple_connections": {
          "label": "Multiple connections"
        },
        "resolve_hosts": {
          "label": "Show hostnames"
        },
        "size": {
          "label": "Size (bytes)",
          "placeholder": "00"
        },
        "snaplen": {
          "label": "Snapshot (bytes)",
          "placeholder": "00"
        },
        "speed_test_source": {
          "all_option": "Site (all circuits)",
          "label": "Speed test source",
          "placeholder": "Select a speed test source"
        },
        "tunnel_role": {
          "label": "Tunnel",
          "option": {
            "primary": "Primary",
            "secondary": "Secondary"
          },
          "placeholder": "Select a tunnel"
        },
        "use_standby_tun": {
          "label": "Use standby tunnel"
        },
        "verbosity_level": {
          "label": "Verbosity",
          "placeholder": "Set verbosity"
        },
        "wait": {
          "label": "Wait (seconds)"
        },
        "write_to_file": {
          "label": "Write to file (.pcap)"
        }
      }
    },
    "flap-circuit": {
      "description": {
        "primary": "Reset the specified circuit interface to help resolve issues encountered when traversing an ISP network.",
        "secondary": "Perform this job to reset the ISP circuit interface and resolve network connectivity or performance issues caused by upstream link problems."
      },
      "details": "Reset the specified circuit interface to help resolve issues encountered when traversing an ISP network.",
      "name": "Reset ISP Circuit",
      "warning": "Executing this action may momentarily interrupt your Bigleaf service. To maintain connectivity, ensure you have another healthy circuit active before proceeding."
    },
    "interface-statistics": {
      "description": {
        "primary": "Inspect the details of the device’s physical interfaces.",
        "secondary": "Perform test to verify the interface’s MAC address and connection status."
      },
      "details": "Verifies the status of the interface, its configuration and shows packet loss.",
      "name": "Device interface status"
    },
    "mtr": {
      "description": {
        "primary": "Combines ping and traceroute to provide detailed insights into network performance, showing the path and latency of data packets.",
        "secondary": "Perform it to diagnose and pinpoint network issues, such as packet loss and latency, across multiple hops."
      },
      "details": "Test the network connections or path between your physical location and your hosting server.",
      "name": "MTR test"
    },
    "ping": {
      "description": {
        "primary": "Checks the connectivity between two devices by measuring the time it takes for a data packet to travel to the destination and back.",
        "secondary": "Perform it to diagnose network issues, such as latency and packet loss, ensuring reliable communication."
      },
      "details": "Test the network connections or path between your physical location and your hosting server.",
      "name": "Ping test"
    },
    "speed-test": {
      "description": {
        "primary": "Measures network bandwidth between CPE and POP server.",
        "secondary": "Perform speed test on specified circuit or entire site."
      },
      "details": "The speed test measures your internet performance by checking download and upload throughput on either a single circuit or the entire site. Tests run inside Bigleaf tunnels, so results will naturally reflect any service‑plan limits or configured circuit speeds. When you choose Site (all circuits), the test reports the combined throughput of every circuit, including those set as backup or avoid‑only paths. For more information see “Speed Test” section in this <helpCenterLink>help center article</helpCenterLink>.",
      "name": "Speed test"
    },
    "tcpdump": {
      "description": {
        "primary": "Captures and analyzes network traffic, providing detailed packet-level data.",
        "secondary": "Perform it to troubleshoot and diagnose network issues, such as identifying security threats and performance bottlenecks."
      },
      "details": "Analyze network traffic by intercepting and displaying packets that are created or received by the computer it's running on.",
      "name": "Tcpdump test"
    }
  },
  "title": "Diagnostics"
}
